import { Chat, Message, User } from "./type";

export const CURRENT_USER: User = { id: 1, name: "Você", is_online: true };

export const MOCK_USERS: User[] = [
];

export const INITIAL_CHATS: Chat[] = [];

export const MOCK_MESSAGES: Record<number, Message[]> = {};